export const government = {
  id: 'government',
  name: 'Government & Public Sector',
  sectionOrder: ['experience', 'education', 'certifications', 'skills'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['harvard-classic'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-centered'
  }
};
export default government;
